"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.environmentFromBackendEnvironment = exports.environmentDeserialize = exports.environmentAll = void 0;
const stringEnumDeserialize_1 = __importDefault(require("./stringEnumDeserialize"));
const tupleForUnionType_1 = require("./tupleForUnionType");
exports.environmentAll = (0, tupleForUnionType_1.tupleForUnionType)({
    DEVELOPMENT: undefined,
    SANDBOX: undefined,
    PRODUCTION: undefined,
});
exports.environmentDeserialize = (0, stringEnumDeserialize_1.default)(exports.environmentAll, 'environment', true);
function environmentFromBackendEnvironment(environment) {
    switch (environment) {
        case 'DEBUG':
            return 'DEVELOPMENT';
        case 'SANDBOX':
            return 'SANDBOX';
        case 'PRODUCTION':
            return 'PRODUCTION';
    }
}
exports.environmentFromBackendEnvironment = environmentFromBackendEnvironment;
